/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amorim API v1
 * Amorim API v1 — Public-facing endpoints (CMS, authentication, authenticated user resources, reservations).
 *
 * **Authentication**
 *
 * - All requests require an `Api-Key` header.
 * - Endpoints that operate on the authenticated user additionally require `Authorization: Bearer <jwt>`.
 * OpenAPI spec version: v1
 */
import type {
  GetExploreCategoriesV1Params,
  GetExploreVenuesV1Params,
  LocationDto,
  ServiceCategoryDto,
  VenueDetailDto,
  VenueGroupDto
} from '../model';

import { customFetch } from '../../../custom-fetch.ts';

export type getExploreCategoriesV1Response200 = {
  data: ServiceCategoryDto[]
  status: 200
}

export type getExploreCategoriesV1Response500 = {
  data: void
  status: 500
}

export type getExploreCategoriesV1ResponseSuccess = (getExploreCategoriesV1Response200) & {
  headers: Headers;
};
export type getExploreCategoriesV1ResponseError = (getExploreCategoriesV1Response500) & {
  headers: Headers;
};

export type getExploreCategoriesV1Response = (getExploreCategoriesV1ResponseSuccess | getExploreCategoriesV1ResponseError)

export const getGetExploreCategoriesV1Url = (params?: GetExploreCategoriesV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/explore/categories?${stringifiedParams}` : `/api/v1/explore/categories`
}

/**
 * Returns service categories (Eat & Drink, Sleep, Spa, …) that have at least one published + active bookable service at the given location. Omitting locationNodeKey returns all categories across the estate.
 * @summary List service categories at a location
 */
export const getExploreCategoriesV1 = async (params?: GetExploreCategoriesV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getExploreCategoriesV1Response> => {

  return customFetch<getExploreCategoriesV1Response>(getGetExploreCategoriesV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type getExploreLocationsV1Response200 = {
  data: LocationDto[]
  status: 200
}

export type getExploreLocationsV1ResponseSuccess = (getExploreLocationsV1Response200) & {
  headers: Headers;
};
;

export type getExploreLocationsV1Response = (getExploreLocationsV1ResponseSuccess)

export const getGetExploreLocationsV1Url = () => {




  return `/api/v1/explore/locations`
}

/**
 * Returns published Location nodes, restricted to the ones configured as a 'Location Discovery' button on the Explore Intro page — that block's Location field is the visibility link, and its Location Name overrides the displayed name. Used to populate the location picker in the Explore module.
 * @summary List locations
 */
export const getExploreLocationsV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<getExploreLocationsV1Response> => {

  return customFetch<getExploreLocationsV1Response>(getGetExploreLocationsV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}


export type getExploreVenuesV1Response200 = {
  data: VenueGroupDto[]
  status: 200
}

export type getExploreVenuesV1Response500 = {
  data: void
  status: 500
}

export type getExploreVenuesV1ResponseSuccess = (getExploreVenuesV1Response200) & {
  headers: Headers;
};
export type getExploreVenuesV1ResponseError = (getExploreVenuesV1Response500) & {
  headers: Headers;
};

export type getExploreVenuesV1Response = (getExploreVenuesV1ResponseSuccess | getExploreVenuesV1ResponseError)

export const getGetExploreVenuesV1Url = (params?: GetExploreVenuesV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/explore/venues?${stringifiedParams}` : `/api/v1/explore/venues`
}

/**
 * Returns venue groups or events that have at least one published + active bookable service at the given location. When serviceCategoryNodeKey resolves to the 'event' category, results are fetched from the event catalog; otherwise results come from the venue group catalog. venueGroupNodeKey narrows results to a single venue group. All parameters are optional.
 * @summary List venues or events at a location
 */
export const getExploreVenuesV1 = async (params?: GetExploreVenuesV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getExploreVenuesV1Response> => {

  return customFetch<getExploreVenuesV1Response>(getGetExploreVenuesV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type getExploreVenueDetailV1Response200 = {
  data: VenueDetailDto
  status: 200
}

export type getExploreVenueDetailV1Response404 = {
  data: void
  status: 404
}

export type getExploreVenueDetailV1Response500 = {
  data: void
  status: 500
}

export type getExploreVenueDetailV1ResponseSuccess = (getExploreVenueDetailV1Response200) & {
  headers: Headers;
};
export type getExploreVenueDetailV1ResponseError = (getExploreVenueDetailV1Response404 | getExploreVenueDetailV1Response500) & {
  headers: Headers;
};

export type getExploreVenueDetailV1Response = (getExploreVenueDetailV1ResponseSuccess | getExploreVenueDetailV1ResponseError)

export const getGetExploreVenueDetailV1Url = (venueNodeKey: string,) => {




  return `/api/v1/explore/venues/${venueNodeKey}`
}

/**
 * Returns the full detail of a single venue node including description, images, GPS coordinates, opening hours, and provider information.
 * @summary Get venue detail
 */
export const getExploreVenueDetailV1 = async (venueNodeKey: string, options?: Parameters<typeof customFetch>[1]): Promise<getExploreVenueDetailV1Response> => {

  return customFetch<getExploreVenueDetailV1Response>(getGetExploreVenueDetailV1Url(venueNodeKey),
  {
    ...options,
    method: 'GET'


  }
);}


